<template>
  <component v-bind:is="layout"></component>
</template>

<script>
"use strict";
import GuestLayout from "@/layouts/Guest";
import AppLayout from "@/layouts/App";
import { URL } from "@/utils/api";
import EventBus from "@/EventBus";
import { mapGetters } from "vuex";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

export default {
  name: "App",
  computed: {
    layout() {
      return (this.$route.meta.layout || "guest") + "-layout";
    },
    ...mapGetters({
      userGroupType: "user/userGroupType",
      userData: "user/userData",
      user: "user/user",
      currentStep: "user/currentStep",
    }),
  },
  components: {
    "guest-layout": GuestLayout,
    "app-layout": AppLayout,
  },
  data() {
    console.log(process.env.VUE_APP_TITLE, "testing env");
    return {
      connected: false,
    };
  },

  methods: {
    connectSocket() {
      this.socket = new SockJS(`${URL[process.env.NODE_ENV].socket_origin}/ws`);
      this.stompClient = Stomp.over(this.socket);
      if (process.env.NODE_ENV === "production")
        this.stompClient.debug = function () {};

      this.stompClient.connect(
        {},
        (_frame) => {
          this.connected = true;

          if (this.userData && this.userData.uuid) {
            const setUserData = {
              id: this.userData.uuid,
              firstName: this.userData.firstName,
              lastName: this.userData.lastName,
              patronymic: this.userData.fatherName,
            };

            this.stompClient.send(
              "/app/setUser",
              JSON.stringify({ user: setUserData }),
              {}
            );
          }

          this.stompClient.subscribe("/topic/amis", async (data) => {
            const body = await JSON.parse(data.body);
            const { eventName } = body;

            if (eventName) EventBus.$emit(eventName, body);
          });
        },
        (error) => {
          this.connected = false;
        }
      );
    },
  },
  created() {
    /*  if (!this.$cookie.get("ASAN-APPEAL-TOKEN")) */
    /*  window.location.href = URL[process.env.NODE_ENV].auth_origin; */

    Number.prototype.pad = function (size) {
      var s = String(this);
      while (s.length < (size || 2)) {
        s = "0" + s;
      }
      return s;
    };

    String.prototype.capitalizeFLetter = function () {
      return this ? this[0].toUpperCase() + this.slice(1) : "";
    };
  },
  mounted() {
    localStorage.setItem(
      "test",
      JSON.stringify(process.env.NODE_ENV) +
        JSON.stringify(process.env.VUE_APP_TITLE)
    );
    console.log(process.env.NODE_ENV, "tetting env");
    // this.connectSocket();
    // EventBus.$on("closedBy", (requestId) => {
    // const msg = { requestId, user: { id: this.userData.uuid } };
    // this.stompClient.send("/app/closedBy", JSON.stringify(msg), {});
    // });
    // EventBus.$on("opened", (msg) => {
    // this.stompClient.send('/app/opened', JSON.stringify(msg), {});
    // })
  },
};
</script>

<style lang="scss" src="./styles.scss"></style>
